export const CATEGORY_META = {
  politics: { label: "Politics", color: "#F59E0B" },
  company: { label: "Company / Live", color: "#22D3EE" },
  game: { label: "Game Release", color: "#A855F7" },
  movie: { label: "Movie / TV", color: "#EC4899" },
  crypto: { label: "Crypto / Protocol", color: "#00FF66" },
  macro: { label: "Macro / Econ", color: "#3B82F6" },
  other: { label: "Other", color: "#94A3B8" },
};

export const CATEGORY_ORDER = ["politics", "company", "game", "movie", "crypto", "macro", "other"];

export const IMPACT_META = {
  bullish: { label: "Bullish", color: "#00FF66" },
  bearish: { label: "Bearish", color: "#FF2E63" },
  neutral: { label: "Neutral", color: "#94A3B8" },
};

export const STATUS_META = {
  scheduled: { label: "Scheduled", color: "#94A3B8" },
  rescheduled: { label: "Rescheduled", color: "#F59E0B" },
  date_tbd: { label: "Date TBD", color: "#A855F7" },
  cancelled: { label: "Cancelled", color: "#FF2E63" },
};

export const CONFIDENCE_META = {
  confirmed: { label: "Confirmed", color: "#00FF66" },
  reported: { label: "Reported", color: "#22D3EE" },
  estimated: { label: "Estimated", color: "#A78BFA" },
  rumored: { label: "Rumored", color: "#F59E0B" },
};

export const SOURCE_META = {
  auto: { label: "Official", color: "#22D3EE" },
  news: { label: "News", color: "#3B82F6" },
  community: { label: "Community", color: "#EC4899" },
  manual: { label: "Curated", color: "#00FF66" },
  ai: { label: "AI draft", color: "#A855F7" },
  private: { label: "Private", color: "#F472B6" },
  x: { label: "X post", color: "#1D9BF0" },
  polymarket: { label: "Polymarket", color: "#6366F1" },
};

export const EVENT_TYPE_LABEL = {
  hearing: "Hearing", trial: "Trial start", sentencing: "Sentencing", ruling: "Ruling", verdict: "Verdict", jury_selection: "Jury selection",
  launch: "Launch", release: "Release", keynote: "Keynote", earnings: "Earnings", speech: "Speech", vote: "Vote", deadline: "Deadline", premiere: "Premiere", trailer: "Trailer",
};

export const catMeta = (c) => CATEGORY_META[c] || CATEGORY_META.other;
export const impMeta = (i) => IMPACT_META[i] || IMPACT_META.neutral;
export const statusMeta = (s) => STATUS_META[s] || STATUS_META.scheduled;
export const confMeta = (c) => CONFIDENCE_META[c] || CONFIDENCE_META.reported;
export const srcMeta = (s) => SOURCE_META[s] || { label: s || "—", color: "#94A3B8" };

export const isTbd = (e) => e.status === "date_tbd" || !e.date;
export const isCancelled = (e) => e.status === "cancelled";
export const isUnpublished = (e) => !e.private && (e.review === "pending" || e.review === "hidden");

// local-date key YYYY-MM-DD from an event date string
export const dayKey = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return (d || "").slice(0, 10);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
};

export const fmtAgo = (iso) => {
  if (!iso) return "";
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  if (m < 2) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 48) return `${h} hour${h === 1 ? "" : "s"} ago`;
  return `${Math.round(h / 24)} days ago`;
};

export const fmtUntil = (iso) => {
  if (!iso) return "";
  const ms = new Date(iso) - Date.now();
  if (ms <= 0) return "now";
  const h = Math.round(ms / 36e5);
  if (h < 1) return `in ${Math.max(1, Math.round(ms / 60000))} min`;
  if (h < 48) return `in ${h}h`;
  return `in ${Math.round(h / 24)}d`;
};
